import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import { configureAmplify } from '@eir/aws-authorization';
import { NotoSansGlobalFonts, PoppinsGlobalFonts } from '@eir/fonts';

import GlobalStyle from './styles/globalStyle';
import PolicyLetterView from './views/PolicyLetter/PolicyLetterView';
import QuoteLetterView from './views/QuoteLetter/QuoteLetterView';
import RoadsideAssistanceCertificateView from './views/RoadsideAssistanceCertificate/RoadsideAssistanceCertificateView';

configureAmplify(
  {
    endpointName: 'KrakenAPI',
    endpointUrl: process.env.REACT_APP_AWS_ENDPOINT_URL,
  },
  true
);

const App = () => {
  return (
    <Router>
      <NotoSansGlobalFonts />
      <PoppinsGlobalFonts />
      <GlobalStyle />
      <Switch>
        <Route
          exact
          path='/p/:policyId'
          render={({ match }) => {
            window.location.href = `${process.env.REACT_APP_PARTNER_HUB_URL}p/${match.params.policyId}`;
            return null;
          }}
        />
        <Route
          exact
          path='/q/:quoteId'
          render={({ match }) => {
            window.location.href = `${process.env.REACT_APP_PARTNER_HUB_URL}q/${match.params.quoteId}`;
            return null;
          }}
        />
        <Route
          exact
          path='/rac/:policyId'
          component={RoadsideAssistanceCertificateView}
        />
        <Route exact path='/p-old/:policyId' component={PolicyLetterView} />
        <Route exact path='/q-old/:quoteId' component={QuoteLetterView} />
        <Redirect from='/:policyId' to='/p/:policyId' />
      </Switch>
    </Router>
  );
};

export default App;
